import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthModal } from '@/context/AuthModalContext'
import { useAppSelector } from '@/store/hooks'
import { selectIsAuthenticated } from '@/store/slices/authSlice'

export function useRequireAuth() {
	const isAuthenticated = useAppSelector(selectIsAuthenticated)
	const { openLogin } = useAuthModal()
	const navigate = useNavigate()

	useEffect(() => {
		if (!isAuthenticated) {
			openLogin()
			navigate('/', { replace: true })
		}
	}, [isAuthenticated, navigate, openLogin])

	return isAuthenticated
}
